import React from 'react';

/**
 * PROPS
 * value = string
 * label = string
 * onChange(value) = func
 */

const VideoInput = props => {
  return (
    <React.Fragment>
      <label className="inp">
        <input autoComplete="off"
          className="inp__field"
          type="text"
          value={props.value}
          onChange={e => props.onChange(e.target.value)}
        />
        <p className="inp__label">{props.label ? props.label : ''}</p>
      </label>
    </React.Fragment>
  );
};

export default VideoInput;
